export default __webpack_public_path__ + "static/media/about.037fe247.png";